var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResultFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.622,
    height: 80,
    viewBox: "0 0 63.622 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_381",
    "data-name": "Union 381",
    d: "M11097.05,13483a9.061,9.061,0,0,1-9.05-9.051v-61.9a9.058,9.058,0,0,1,9.05-9.049h34.026a1.811,1.811,0,0,1,1.253.5l18.734,17.959a1.809,1.809,0,0,1,.559,1.307v51.182a9.063,9.063,0,0,1-9.051,9.051Zm-5.431-70.951v61.9a5.438,5.438,0,0,0,5.431,5.43h45.521a5.436,5.436,0,0,0,5.43-5.43v-49.527h-11.5a7.247,7.247,0,0,1-7.24-7.238v-10.564h-32.216A5.436,5.436,0,0,0,11091.619,13412.049Zm41.268,5.135a3.624,3.624,0,0,0,3.619,3.619h8.641l-12.26-11.752Zm-26.583,50.139a1.809,1.809,0,0,1-1.811-1.809v-8.092a12.257,12.257,0,0,1,12.243-12.242h6.255a12.108,12.108,0,0,1,12.136,12.051v8.283a1.809,1.809,0,0,1-1.81,1.809Zm1.811-9.9v6.281h23.393v-6.473a8.484,8.484,0,0,0-8.516-8.432h-6.255A8.633,8.633,0,0,0,11108.114,13457.422Zm2.62-21.768a8.8,8.8,0,1,1,8.8,8.8A8.8,8.8,0,0,1,11110.734,13435.654Zm3.62,0a5.177,5.177,0,1,0,5.177-5.178A5.175,5.175,0,0,0,11114.354,13435.656Z",
    transform: "translate(-11088 -13403)",
    fill: "#ddd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultFound);
export default __webpack_public_path__ + "static/media/no_result_found.3a82286c4f6606ed4e500f8f101bd62b.svg";
export { ForwardRef as ReactComponent };